import React from "react";
import { motion } from "framer-motion";
import { pageMotion } from "../../framer/animation";
import SliderPage from "../../components/SliderPage/SliderPage";
import { Notes, Title } from "../../styles/reusables";
import { FaQuestionCircle } from "react-icons/fa";
import { AboutSection } from "./styles";
import { ReactComponent as AboutInfo } from "../../assets/img/about.svg";
import { Link } from "react-router-dom";

const About = () => {
	return (
		<>
			<SliderPage />
			<motion.div
				variants={pageMotion}
				initial='hidden'
				animate='show'
				exit='exit'
			>
				<Title>
					<FaQuestionCircle />
					<h2>About</h2>
				</Title>
				<AboutSection>
					<div className='image'>
						<AboutInfo />
					</div>
					<Notes>
						<p className='note'>
							My name is Amirkhon Shakirov, 25 y.o. Entrepreneur, manager, and
							salesman in the past. <span>Front-end web developer</span> present
							days.
						</p>
						<p className='note'>
							The pandemic forced me to reconsider my plans for life or
							concentrate on something I planned many times but never started.
							And it is <span>Coding</span>!
						</p>
						<p className='note'>
							I have always been interested in the process of creating games,
							user interfaces, softwares and etc. I had a big dream of having my
							own popular game. May be there's still a chance, but right now...
						</p>
						<p className='note'>
							I offer my front-end web development skills that allows me to
							create websites for small or medium sized companies.
						</p>
						<div className='btn-container'>
							<button>
								<Link to='/skills'>Skills</Link>
							</button>
						</div>
					</Notes>
				</AboutSection>
			</motion.div>
		</>
	);
};

export default About;
